module.exports = __webpack_public_path__ + "img/20180815_150609_105.9bf1d2dd.jpg";